export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10977.f307f15d.jpg";